import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useState } from 'react';
import { analytics } from '../..';
import Api from '../../services/api';
import { AnalyticsEvents } from '../../store/AnalyticsStore';
import pathFinderStore from '../../store/PathFinderStore/PathFinderStore';
import UITranslations from "../../store/uiTranslations";
import TranslatedText from "../ui/TranslatedText/TranslatedText";
import './PathRating.css';



const enum Rating {
    Yes = 'yes',
    No = 'no'
}

const PathRating:FunctionComponent = () => {
    const ui = UITranslations.PhotoRoutePage.PathRating;
    const [rating, setRating] = useState<Rating|undefined>(undefined);

    const handleRatingClick = (value:Rating) => () => {
        if (!rating) {
            analytics.logEvent(AnalyticsEvents.ClickWasInstructionHelpful, {
                isHelpful: value === Rating.Yes
            })

            setRating(value);

            const statId = pathFinderStore.pathFinder?.statisticId
            if (statId) {
                Api.patchStatistic(statId, {
                    found: value === Rating.Yes
                })
            }
        }
    }

    return <div className="path-rating">
        <div className="path-rating__question-container mb-10">
            <p className="text-center"><TranslatedText source={ui.Question}/></p>
            <hr/>
            <div className="row">
                <div className="col-xs-6">
                    <button type="button"
                            className={`btn btn-link 
                                path-rating__button path-rating__button--positive 
                                ${rating === Rating.Yes && 'path-rating__button--positive-selected'}
                                ${rating === Rating.No && 'disabled'}`}
                            onClick={handleRatingClick(Rating.Yes)}>
                        <FontAwesomeIcon icon="thumbs-up" size="lg" className="mr-10"/>
                        <TranslatedText source={ui.PositiveAnswer}/>
                    </button>
                </div>
                <div className="col-xs-6">
                    <button type="button"
                            className={`btn btn-link 
                                path-rating__button path-rating__button--negative 
                                ${rating === Rating.No && 'path-rating__button--negative-selected'}
                                ${rating === Rating.Yes && 'disabled'}`}
                            onClick={handleRatingClick(Rating.No)}>
                        <FontAwesomeIcon icon="thumbs-down" size="lg" className="mr-10"/>
                        <TranslatedText source={ui.NegativeAnswer}/>
                    </button>
                </div>
            </div>
        </div>
        {rating && <p className="text-center text-italic"><TranslatedText source={ui.ThankYouMessage}/></p>}
    </div>
};

export default  PathRating;
